import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Grid, TextField, Typography } from "@mui/material";
import { AuthLayout } from '../layout/AuthLayout';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import { useAuthStore } from '../../store';





export const LoginScreen = () => {

    const { startLoginUser } = useAuthStore();
    const navigate = useNavigate();


    
    const [formLogin, setFormLogin] = useState({ email: '', password: '' });
    const { email, password } = formLogin;
    const handleInputChange = ({ target }) => {
        setFormLogin({
            ...formLogin,
            [target.name]: target.value
        });
    }


    const handleSubmit = async(e) => {
        e.preventDefault();
        await startLoginUser({email, password});
    }


    const volverHome = () => {
        navigate('/home');
    }


    return (

        <AuthLayout tittle='Login' >
            <form onSubmit={ handleSubmit } >
                <Grid container >

                    <Grid item xs={ 12 } mt={ 2 }>
                        <TextField
                            label='Correo'
                            type='email'
                            placeholder='Correo'
                            fullWidth
                            name='email'
                            value={ email }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={ 12 } mt={ 2 }>
                        <TextField
                            label='Contraseña'
                            type='password'
                            placeholder='Contraseña'
                            fullWidth
                            name='password'
                            value={ password }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid container spacing={ 2 } sx={{ mb:2, mt:2 }} diplay="flex" justifyContent="center" >
                        <Grid item xs={ 12 } sm={ 8 } >
                            <Button variant='contained' fullWidth type="submit" >
                                Login
                            </Button>
                        </Grid>

                        <Grid item xs={ 12 } sm={ 8 } >
                            <Button variant='contained' fullWidth onClick={ volverHome } >
                                <ArrowCircleLeftIcon />
                                <Typography sx={{ ml:1 }}>Volver Al Home</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                    
                </Grid>
            </form>
        </AuthLayout>

    )
}
